
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const RequestsHeader = () => {
  const navigate = useNavigate();
  
  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">
          Administrativ panel
        </h1>
        <p className="text-sm text-muted-foreground">
          Hantera gruppledare och se översikt över registrerad data
        </p>
      </div>
      <Button variant="outline" onClick={() => navigate("/admin/dashboard")}>
        Tillbaka till dashboard
      </Button>
    </div>
  );
};

export default RequestsHeader;
